import React from 'react';
import classnames from 'classnames';

import './style.scss';
import { CONTENT_TYPES } from '../../../config/constants';

const SearchTagIcon = (props) => {
  const { contentType } = props;
  let icon = '';

  switch (contentType) {
    case CONTENT_TYPES.ARTICLE:
    case CONTENT_TYPES.TOOL:
    case CONTENT_TYPES.EXPERT:
    case CONTENT_TYPES.ELEARNING:
    case CONTENT_TYPES.INTERVENTION:
    case CONTENT_TYPES.VACANCY:
      icon = contentType === CONTENT_TYPES.ARTICLE || contentType === CONTENT_TYPES.MILESTONES ? 'copy' : 'gear';
      break;
    case CONTENT_TYPES.DOWNLOAD:
    case CONTENT_TYPES.RESEARCH:
      icon = contentType === CONTENT_TYPES.DOWNLOAD ? 'download' : 'light';
      break;
    case CONTENT_TYPES.PRACTICAL_EXAMPLE:
    case CONTENT_TYPES.EVENT:
      icon = contentType === 'event' ? 'book' : 'board';
      break;
    default:
      icon = 'web';
  }

  return (
    <div className={`icon icon-${icon}`} />
  );
};
const SearchTag = ({ text, type, className }) => {
  return (
    <div className={classnames('SearchTag', className)}>
      {type && <SearchTagIcon contentType={type} />}
      <span>{text}</span>
    </div>
  );
};

export default SearchTag;
